import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SettingsLayout } from '@/components/settings/settings-layout';

export const Route = createFileRoute('/_authenticated/settings')({
  staticData: {
    title: 'route.settings.title',
    messageContext: { context_type: 'workspace' },
  },
  component: SettingsRouteShell,
});

function SettingsRouteShell(): React.ReactElement {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}
